/**
 * privacy
 */
'use strict';
import AppPrivacy from '@/_modules/app_privacy';

document.addEventListener('DOMContentLoaded', () => {
  new AppPrivacy();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
